module.exports = __webpack_public_path__ + "img/app_logo.6950e306.png";